module.exports = "/_next/static/images/verified-3751d1b3eedbb4c47c0d536f1858268f.svg";